"use strict";

var _WKTWriter = _interopRequireDefault(require("./io/WKTWriter"));

var _IsValidOp = _interopRequireDefault(require("./operation/valid/IsValidOp"));

var _InteriorPointArea = _interopRequireDefault(require("./algorithm/InteriorPointArea"));

var _UnaryUnionOp = _interopRequireDefault(require("./operation/union/UnaryUnionOp"));

var _UnionOp = _interopRequireDefault(require("./operation/union/UnionOp"));

var _InteriorPointLine = _interopRequireDefault(require("./algorithm/InteriorPointLine"));

var _IsSimpleOp = _interopRequireDefault(require("./operation/IsSimpleOp"));

var _BufferOp = _interopRequireDefault(require("./operation/buffer/BufferOp"));

var _ConvexHull = _interopRequireDefault(require("./algorithm/ConvexHull"));

var _Centroid = _interopRequireDefault(require("./algorithm/Centroid"));

var _RelateOp = _interopRequireDefault(require("./operation/relate/RelateOp"));

var _InteriorPointPoint = _interopRequireDefault(require("./algorithm/InteriorPointPoint"));

var _DistanceOp = _interopRequireDefault(require("./operation/distance/DistanceOp"));

var _OverlayOp = _interopRequireDefault(require("./operation/overlay/OverlayOp"));

var _Geometry = _interopRequireDefault(require("./geom/Geometry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Geometry.default.prototype.equalsTopo = function (g) {
  if (!this.getEnvelopeInternal().equals(g.getEnvelopeInternal())) return false;
  return _RelateOp.default.relate(this, g).isEquals(this.getDimension(), g.getDimension());
};

_Geometry.default.prototype.union = function () {
  if (arguments.length === 0) {
    return _UnaryUnionOp.default.union(this);
  } else if (arguments.length === 1) {
    var other = arguments[0];
    return _UnionOp.default.union(this, other);
  }
};

_Geometry.default.prototype.isValid = function () {
  return _IsValidOp.default.isValid(this);
};

_Geometry.default.prototype.intersection = function (other) {
  return _OverlayOp.default.intersection(this, other);
};

_Geometry.default.prototype.covers = function (g) {
  return _RelateOp.default.covers(this, g);
};

_Geometry.default.prototype.coveredBy = function (g) {
  return _RelateOp.default.covers(g, this);
};

_Geometry.default.prototype.touches = function (g) {
  return _RelateOp.default.touches(this, g);
};

_Geometry.default.prototype.intersects = function (g) {
  return _RelateOp.default.intersects(this, g);
};

_Geometry.default.prototype.within = function (g) {
  return _RelateOp.default.contains(g, this);
};

_Geometry.default.prototype.overlaps = function (g) {
  return _RelateOp.default.overlaps(this, g);
};

_Geometry.default.prototype.disjoint = function (g) {
  return _RelateOp.default.disjoint(this, g);
};

_Geometry.default.prototype.crosses = function (g) {
  return _RelateOp.default.crosses(this, g);
};

_Geometry.default.prototype.buffer = function () {
  if (arguments.length === 1) {
    var distance = arguments[0];
    return _BufferOp.default.bufferOp(this, distance);
  } else if (arguments.length === 2) {
    var _distance = arguments[0],
        quadrantSegments = arguments[1];
    return _BufferOp.default.bufferOp(this, _distance, quadrantSegments);
  } else if (arguments.length === 3) {
    var _distance2 = arguments[0],
        _quadrantSegments = arguments[1],
        endCapStyle = arguments[2];
    return _BufferOp.default.bufferOp(this, _distance2, _quadrantSegments, endCapStyle);
  }
};

_Geometry.default.prototype.convexHull = function () {
  return new _ConvexHull.default(this).getConvexHull();
};

_Geometry.default.prototype.relate = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (arguments.length === 1) {
    var geometry = arguments[0];
    return _RelateOp.default.relate(this, geometry);
  } else if (arguments.length === 2) {
    var _geometry = arguments[0],
        intersectionPattern = arguments[1];
    return _RelateOp.default.relate(this, _geometry).matches(intersectionPattern);
  }
};

_Geometry.default.prototype.getCentroid = function () {
  if (this.isEmpty()) return this._factory.createPoint();

  var centPt = _Centroid.default.getCentroid(this);

  return this.createPointFromInternalCoord(centPt, this);
};

_Geometry.default.prototype.getInteriorPoint = function () {
  if (this.isEmpty()) return this._factory.createPoint();
  var interiorPt = null;
  var dim = this.getDimension();

  if (dim === 0) {
    var intPt = new _InteriorPointPoint.default(this);
    interiorPt = intPt.getInteriorPoint();
  } else if (dim === 1) {
    var intPt = new _InteriorPointLine.default(this);
    interiorPt = intPt.getInteriorPoint();
  } else {
    var intPt = new _InteriorPointArea.default(this);
    interiorPt = intPt.getInteriorPoint();
  }

  return this.createPointFromInternalCoord(interiorPt, this);
};

_Geometry.default.prototype.symDifference = function (other) {
  return _OverlayOp.default.symDifference(this, other);
};

_Geometry.default.prototype.createPointFromInternalCoord = function (coord, exemplar) {
  exemplar.getPrecisionModel().makePrecise(coord);
  return exemplar.getFactory().createPoint(coord);
};

_Geometry.default.prototype.toText = function () {
  var writer = new _WKTWriter.default();
  return writer.write(this);
};

_Geometry.default.prototype.toString = function () {
  this.toText();
};

_Geometry.default.prototype.contains = function (g) {
  return _RelateOp.default.contains(this, g);
};

_Geometry.default.prototype.difference = function (other) {
  return _OverlayOp.default.difference(this, other);
};

_Geometry.default.prototype.isSimple = function () {
  var op = new _IsSimpleOp.default(this);
  return op.isSimple();
};

_Geometry.default.prototype.isWithinDistance = function (geom, distance) {
  var envDist = this.getEnvelopeInternal().distance(geom.getEnvelopeInternal());
  if (envDist > distance) return false;
  return _DistanceOp.default.isWithinDistance(this, geom, distance);
};

_Geometry.default.prototype.distance = function (g) {
  return _DistanceOp.default.distance(this, g);
};

_Geometry.default.prototype.isEquivalentClass = function (other) {
  return this.getClass() === other.getClass();
};